// extracted by mini-css-extract-plugin
export var infoItem = "_tz-2";
export var title = "_tz-0";
export var value = "_tz-1";